import BoilerplateLayout from './BoilerplateLayout'

export default BoilerplateLayout
